import { FC } from 'react';
import { PageSpinner } from 'src/components/spinner-container';
import { useAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';
import { useRemitReportingSubscriptionInfo } from 'src/pages/reporting/secondary-tradings/overview/use-remit-reporting-subscription-info';
import Page from 'src/pages/settings/premium-services/page';
import { usePremiumServicesBillingAddress } from 'src/pages/settings/premium-services/use-premium-services-billing-address';
import { useServicePackages } from 'src/pages/settings/premium-services/use-service-packages';
import { useShipperBriefInfo } from 'src/pages/settings/premium-services/use-shipper-brief-info';
import { useShipperPremiumServices } from 'src/pages/settings/premium-services/use-shipper-premium-services';

export const PremiumServices: FC = () => {
  const monolithUser = useAuthenticatedMonolithUser();
  const servicePackagesRequest = useServicePackages();
  const shipperPremiumServicesRequest = useShipperPremiumServices(
    monolithUser.referenceId
  );
  const remitReportingSubscriptionInfoRequest =
    useRemitReportingSubscriptionInfo('SECONDARY');
  const shipperBriefInfoRequest = useShipperBriefInfo(monolithUser.referenceId);
  const premiumServicesBillingAddressRequest = usePremiumServicesBillingAddress(
    monolithUser.referenceId
  );

  if (
    (remitReportingSubscriptionInfoRequest &&
      !remitReportingSubscriptionInfoRequest.response) ||
    !servicePackagesRequest.response ||
    !shipperPremiumServicesRequest.response ||
    !shipperBriefInfoRequest.response ||
    !premiumServicesBillingAddressRequest.response
  ) {
    return <PageSpinner />;
  }

  return (
    <Page
      remitReportingSubscriptionInfoRequest={
        remitReportingSubscriptionInfoRequest
      }
      servicePackagesRequest={servicePackagesRequest}
      shipperPremiumServicesRequest={shipperPremiumServicesRequest}
      shipperBriefInfoRequest={shipperBriefInfoRequest}
      premiumServicesBillingAddressRequest={
        premiumServicesBillingAddressRequest
      }
      referenceId={monolithUser.referenceId}
    />
  );
};
